import React from "react";
import "./map.css";
import Tab from "../tab/tab";
import location from "../../../assets/img/location.png";
import map from "../../../assets/img/map.png";
import flower from "../../../assets/img/flower_light.png";

export default function Map({ showTab = true, variant = "default" }) {
  const isMain = variant === "main";

  return (
    <div className={`map-page ${isMain ? "map-page-main" : ""}`}>
      {showTab && <Tab />}

      <div className="map-content">
        <div className={isMain ? "main-location-area" : ""}>
          <div className="map-section">
            {isMain && (
              <>
                <img src={flower} alt="" className="map-main-flower" />
                <h3 className="map-main-title">총학생회실 위치</h3>
                <div
                  className="map-main-title-bar"
                  aria-hidden="true"
                ></div>
              </>
            )}

            <div className="location-row">
              <img src={location} alt="위치" className="location-image" />
              <h2>덕성여자대학교 총학생회실</h2>
            </div>

            <p>
              서울특별시 도봉구 삼양로144길 33, 덕성여자대학교 학생회관 2층
            </p>
          </div>

          <div className="map-section">
            <iframe
              src="https://www.google.com/maps?q=덕성여자대학교&output=embed"
              width="100%"
              height="533px"
              title="덕성여자대학교 총학생회실 위치"
            />
          </div>
        </div>

        <div className="campus-map-section">
          <img src={flower} alt="" className="flower-image" />
          <h3 className="campus-map-title">
            캠퍼스맵(쌍문근화캠퍼스)
          </h3>
          <img src={map} alt="캠퍼스맵" />
        </div>
      </div>
    </div>
  );
}